import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class DownloadQrCodeService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  downloadQrCode(className: string): void {
    const element = this.document.getElementsByClassName(className);
    const img = element[0].getElementsByTagName('img');
    const imageSrcBase64 = img[0].currentSrc;

    const link = this.document.createElement('a');
    link.href = imageSrcBase64;
    link.download = className;
    link.click();
  }
}
